<template>
  <div id="func-63">
    <div style="padding: 20px">
      <div v-if="isLoading">Carregando..</div>
      <el-alert
        type="error"
        v-if="error.show"
        :show-icon="true"
        :description="error.message"
        :closable="false"
      />
      <MemedEmbed
        v-else-if="memedConfig.token"
        :token="memedConfig.token"
        :instancia-aplicacao="memedConfig.instanciaAplicacao"
        :paciente="paciente"
        @isLoading="(loading) => isLoading = loading"
        @newPrescription="newPrescription"
      />
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import { UtilitarioResource } from '@/API'
import MemedEmbed from '@/views/63/MemedEmbed.vue'
import moment from 'moment'
import { emitNewPrescription } from '@/utils/comandosSdk'

export default {
  name: 'Func63',
  components: { MemedEmbed },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'embedJson', 'frameId']),
    ...mapGetters('SetupApp', ['estilo', 'isWidget', 'bundle']),
    ...mapGetters('Login', ['dadosUsuarioLogado']),
    parametros () {
      return this.funcionalidade.parametros
    }
  },
  data () {
    return {
      isLoading: false,
      memedConfig: {
        token: false,
        instanciaAplicacao: null
      },
      paciente: {
        id: null,
        nome: null,
        telefone: null,
        cpf: null,
        dataNascimento: null
      },
      error: {
        show: false,
        message: null
      }
    }
  },
  created () {
    this.iniciarAtendimento()
  },
  methods: {
    async iniciarAtendimento () {
      try {
        this.hideError()
        if (
          !this.embedJson.atendimento ||
          typeof this.embedJson.atendimento !== 'object' ||
          !this.embedJson.atendimento.tokenAtendente
        ) {
          this.setError('Falha na autenticação.')
        }

        this.isLoading = true
        const atendimento = await UtilitarioResource.iniciarAtendimentoMemed({
          authorization: this.embedJson.atendimento.tokenAtendente,
          chaveUnica: !this.dadosUsuarioLogado ? this.embedJson.atendimento.chaveUnica : undefined,
          bundle: this.bundle,
          instanciaAplicacao: this.embedJson.instanciaAplicacao
        })
        this.isLoading = false
        if (atendimento.code) {
          switch (atendimento.code) {
            case 401:
              this.setError('Falha na autenticação.')
              break
            default:
              this.setError(atendimento.data.message)
              break
          }
        }

        if (atendimento.statusCode) {
          switch (atendimento.statusCode) {
            case 200:
              const userData = this.dadosUsuarioLogado
              const paciente = {}
              if (userData && userData.dadosPessoais) {
                paciente.id = userData.chaveUnica
                paciente.nome = userData.dadosPessoais.nome
                paciente.cpf = userData.dadosPessoais.cpf
                if (userData.dadosPessoais.contato) {
                  paciente.telefone = userData.dadosPessoais.contato.telefoneCelular || userData.dadosPessoais.contato.telefoneFixo
                }

                if (userData.dadosPessoais.dataNascimento) {
                  const date = moment(userData.dadosPessoais.dataNascimento, 'YYYY-MM-DD', true)
                  if (date.isValid()) {
                    paciente.dataNascimento = date.format('DD/MM/YYYY')
                  }
                }
              }

              this.startMemed({
                ...atendimento.data,
                paciente
              })
              break
            default:
              this.setError(atendimento.data.message)
              break
          }
        }
      } catch (e) {
        this.setError(e.message)
      }
    },
    startMemed (data) {
      this.memedConfig = {
        token: data.token,
        instanciaAplicacao: parseInt(this.embedJson.instanciaAplicacao)
      }

      if (data.paciente) {
        this.paciente = data.paciente
      }
    },
    setError (message) {
      this.error = {
        show: true,
        message: message
      }
    },
    hideError () {
      this.error = {
        show: false,
        message: null
      }
    },
    newPrescription (prescriptionData) {
      emitNewPrescription(this.frameId, prescriptionData)
    }
  }
}
</script>

<style>
</style>
